export const questionnaireNoticeData = {
  zh: `感谢您参加此次家庭友好企业调查！

家庭友好企业，是指在对内支持员工履行家庭责任、对外为社会家庭友好作出贡献这两个方面均表现突出的企业。本问卷从"雇员家庭友好支持"与"家庭友好社会贡献"两个层面构建评价逻辑，旨在全面反映企业在促进员工工作与家庭平衡、履行社会责任方面的实践水平。

问卷分为三个核心模块：

- 第一模块是企业基础信息，我们希望收集贵司基础信息，用于了解贵司的基本情况；
- 第二模块是雇员家庭友好支持，此模块聚焦企业对内部员工家庭的支持，涵盖时间灵活、资金资源、服务照护、职业文化；
- 第三模块是家庭友好社会贡献，此模块为可选作答部分，关注企业是否在产品服务设计或公益行动中，对外部社会家庭友好作出贡献。

**为了保证公平性和结果的权威性，我们会在问卷填写一段时间后抽样收集证明材料。**`,

  zh_TW: `感謝您參加此次家庭友善企業調查！

家庭友善企業，是指在對內支持員工履行家庭責任、對外為社會家庭友好作出貢獻這兩個方面均表現突出的企業。本問卷從「雇員家庭友好支持」與「**家庭友好社會貢獻**」兩個層面構建評價邏輯，旨在全面反映企業在促進員工工作與家庭平衡、履行社會責任方面的實踐水平。

本問卷分為三個核心模塊：

- **第一模塊：企業基礎信息** — 我們希望收集貴企業的基礎信息，以了解其組織概況；
- **第二模塊：雇員家庭友好支持** — 此模組聚焦企業對內部員工家庭責任的支持，涵蓋時間靈活、資金資源、服務照護與職業文化四個維度；
- **第三模塊：家庭友好社會貢獻** — 此模組為可選作答部分，關注企業是否在產品服務設計或公益行動中，對外部社會的家庭友好作出貢獻。

**爲了保證公平性和結果的權威性，我們會在問卷填寫一段時間後抽樣收集證明材料。**`,

  en: `Thank you for participating in this Family Friendly Employers survey!

A family-friendly employer refers to an organization that demonstrates outstanding performance in two dimensions: internally supporting employees in fulfilling their family responsibilities, and externally contributing to family-friendliness in society. This questionnaire constructs its evaluation framework around two levels—“employee family-friendly support” and “**family-friendly societal contributions**”—with the aim of comprehensively reflecting the enterprise’s practices in promoting work-family balance among employees and fulfilling its social responsibilities.

This questionnaire consists of three core modules:

- **Module 1: Enterprise Basic Information** — We seek to collect fundamental information about your enterprise to understand its organizational profile;
- **Module 2: Employee Family-Friendly Support** — This module focuses on the enterprise’s support for employees’ family responsibilities, covering four dimensions: time flexibility, financial resources, service care, and occupational culture;
- **Module 3: Family-friendly Societal Contributions** — This module is optional and examines whether the enterprise contributes to family-friendliness in society through product/service design or public welfare initiatives.

**To ensure fairness and the authority of the results, we will collect supporting materials through sampling after the questionnaire has been completed for a certain period of time.**`,
};
